import { writable } from "svelte/store";
import type { SurveyQuestion } from "../helpers/steps/survey";

export const SURVEY_TYPES: Record<string, string> = {
  REGULAR_SURVEY: "regular_survey",
  FOLLOW_UP_SURVEY: "follow_up_survey"
};

export type SurveyAnswers = Record<string, Array<string>>

export type SurveyStore = {
  currentIndex?: number;
  questions?: SurveyQuestion[];
  answers: SurveyAnswers;
  type?: string;
  isComplete: boolean;
};

export function setSurvey(store: SurveyStore) {
  surveyStore.set(store);
}

export const updateSurvey = (update: Partial<SurveyStore>) => {
  surveyStore.update((data) => {
    return {
      ...data,
      ...update
    };
  });
};

export function initStore() {
  const store = writable<SurveyStore>();
  store.set({
    answers: {},
    isComplete: false
  });
  return store;
}

export const surveyStore = initStore();
